import { useSyncExternalStore } from 'react';

/**
 * Ein Hinweis, der einen Seitenwechsel überlebt.
 *
 * Beim Backup-Import stand die Meldung („als Kopie importiert", Warnungen
 * aus dem Import) auf der Turnierliste — und im selben Augenblick ging es
 * weiter ins Turnier. Gesehen hat sie niemand. Jetzt merkt sich die Liste
 * den Hinweis hier, und der Turnier-Rahmen (layout/AppShell) zeigt ihn an,
 * bis er weggetippt wird.
 *
 * Die Texte sind deutsch (Wörterbuch-Schlüssel oder Meldungen aus
 * `@airmail/io`) — übersetzt wird beim Anzeigen, damit ein Sprachwechsel
 * nachwirkt.
 */
export interface Hinweis {
  ton: 'ok' | 'hinweis' | 'fehler';
  /** schon übersetzte oder deutsche Einzeltexte — beim Anzeigen mit `tm` übersetzt und mit · verbunden */
  texte: string[];
  /** Platzhalter für den ersten Text */
  werte?: Record<string, string | number>;
  /** nur in diesem Turnier zeigen — sonst tauchte er beim nächsten geöffneten wieder auf */
  turnier?: string;
}

let aktuell: Hinweis | null = null;
const hoerer = new Set<() => void>();

export function merkeHinweis(h: Hinweis | null): void {
  aktuell = h;
  for (const fn of hoerer) fn();
}

export function useGemerkterHinweis(): Hinweis | null {
  return useSyncExternalStore(
    (fn) => {
      hoerer.add(fn);
      return () => hoerer.delete(fn);
    },
    () => aktuell,
  );
}
